import { Bar, CartesianGrid, ComposedChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { formatMoney, formatMoneyFull } from "@/lib/money"
import { monthShort } from "./format"
import type { YearProgressMonth } from "./types"

const ESTIMATE_FILL = "color-mix(in srgb, var(--chart-1) 35%, transparent)"

// Each month of the plan: the plan beside what was sold, with the estimate
// for the rest of the month stacked on top.
export default function YearProgressChart({ currency, months }: { currency: string | null; months: YearProgressMonth[] }) {
  const withYear = new Set(months.map((m) => m.month.slice(0, 4))).size > 1
  const data = months.map((m) => ({ ...m, label: monthShort(m.month, withYear) }))
  return (
    <ResponsiveContainer width="100%" height={220}>
      <ComposedChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }} barCategoryGap="22%" barGap={2}>
        <CartesianGrid vertical={false} stroke="var(--chart-grid)" />
        <XAxis dataKey="label" tick={{ fontSize: 11, fill: "var(--chart-axis)" }} axisLine={false} tickLine={false} />
        <YAxis
          tickFormatter={(v) => formatMoney(Number(v), currency)}
          tick={{ fontSize: 11, fill: "var(--chart-axis)" }}
          axisLine={false}
          tickLine={false}
          width={64}
        />
        <Tooltip
          formatter={(v) => (v == null ? "-" : formatMoneyFull(Number(v), currency))}
          cursor={{ fill: "var(--muted)" }}
          contentStyle={{ fontSize: 12, borderRadius: 6, borderColor: "var(--border)" }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} iconType="square" iconSize={10} />
        <Bar dataKey="plan" name="Plan" fill="var(--chart-muted)" maxBarSize={18} radius={[3, 3, 0, 0]} isAnimationActive={false} />
        <Bar dataKey="actual" name="Actual" stackId="real" fill="var(--chart-1)" maxBarSize={18} isAnimationActive={false} />
        <Bar dataKey="estimate" name="Forecast" stackId="real" fill={ESTIMATE_FILL} maxBarSize={18} radius={[3, 3, 0, 0]} isAnimationActive={false} />
      </ComposedChart>
    </ResponsiveContainer>
  )
}
